export const imageGridCards = 
[
    {
    "id": "2568312",
    "imageId": "PC_Mweb/Cake.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
        "text": "Cakes",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for cake",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, 
{
    "id": "2568016",
    "imageId": "PC_Mweb/Pizza.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
        "text": "Pizzas",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for pizza",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568034",
    "imageId": "PC_Mweb/Rolls.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
        "text": "Rolls",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for roll",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568353",
    "imageId": "PC_Mweb/Momo.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
        "text": "Momos",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for momos",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568326",
    "imageId": "PC_Mweb/Ice%20Cream.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83640?collection_id=83640&tags=layout_CCS_IceCreams&type=rcv2",
        "text": "Ice Cream",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for icecream",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83640?collection_id=83640&tags=layout_CCS_IceCreams&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568041",
    "imageId": "PC_Mweb/Pasta.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
        "text": "Pasta",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for pasta",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568142",
    "imageId": "PC_Mweb/Dosa.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
        "text": "Dosa",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for dosa",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568360",
    "imageId": "PC_Mweb/Pure%20Veg.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
        "text": "Pure Veg",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for veg",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568314",
    "imageId": "PC_Mweb/Idli.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80440?collection_id=80440&search_context=idli&tags=layout_CCS_Idli&type=rcv2",
        "text": "Idli",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for idly",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80440?collection_id=80440&search_context=idli&tags=layout_CCS_Idli&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568009",
    "imageId": "PC_Mweb/Chinese.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
        "text": "Chinese",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for chinese",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568359",
    "imageId": "PC_Mweb/Paratha.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80475?collection_id=80475&type=rcv2",
        "text": "Paratha",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for paratha",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80475?collection_id=80475&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568019",
    "imageId": "PC_Mweb/Tea.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80406?collection_id=80406&tags=layout_CCS_Tea&type=rcv2",
        "text": "Tea",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for tea",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80406?collection_id=80406&tags=layout_CCS_Tea&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568332",
    "imageId": "PC_Mweb/Coffee.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83659?collection_id=83659&tags=layout_CCS_Coffee&type=rcv2",
        "text": "Coffee",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for coffee",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83659?collection_id=83659&tags=layout_CCS_Coffee&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568358",
    "imageId": "PC_Mweb/North%20Indian.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83633?collection_id=83633&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
        "text": "North Indian",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for north indian",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83633?collection_id=83633&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568349",
    "imageId": "PC_Mweb/Samosa.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
        "text": "Samosa",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for samosa",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568339",
    "imageId": "PC_Mweb/Biryani.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
        "text": "Biryani",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for biryani",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568547",
    "imageId": "PC_Mweb/Poha.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80373?collection_id=80373&tags=layout_CCS_Poha&type=rcv2",
        "text": "Poha",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for poha",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80373?collection_id=80373&tags=layout_CCS_Poha&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568324",
    "imageId": "PC_Mweb/Khichdi.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80455?collection_id=80455&type=rcv2",
        "text": "Khichdi",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurants curated for khichdi",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80455?collection_id=80455&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568372",
    "imageId": "PC_Mweb/Desserts.png",
    "action": {
        "link": "https://www.swiggy.com/collections/83661?collection_id=83661&search_context=desserts&tags=layout_CCS_Desserts&type=rcv2",
        "text": "Dessert",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for dessert",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/83661?collection_id=83661&search_context=desserts&tags=layout_CCS_Desserts&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}, {
    "id": "2568198",
    "imageId": "PC_Mweb/Lassi.png",
    "action": {
        "link": "https://www.swiggy.com/collections/80458?collection_id=80458&type=rcv2",
        "text": "Lassi",
        "type": "DEEPLINK"
    },
    "entityType": "BANNER",
    "accessibility": {
        "altText": "restaurant curated for lassi",
        "altTextCta": "open"
    },
    "entityId": "https://www.swiggy.com/collections/80458?collection_id=80458&type=rcv2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "overlayIcon": {}
}]